import { Trans } from 'react-i18next'

import { Switch } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { AccordionItem } from '@/components/Accordion/Accordion'

export default function SwitchAccordionItem() {
  const {
    showLanguageSwitcher,
    setShowLanguageSwitcher,
    showThemeSwitcher,
    setShowThemeSwitcher,
    topBarVisibility,
    updateProjectSwitchers,
  } = useAppBuilderContext()

  const handleToggleLanguageSwitcher = async (value: boolean) => {
    setShowLanguageSwitcher(value)
    await updateProjectSwitchers(value, undefined)
  }

  const handleToggleThemeSwitcher = async (value: boolean) => {
    setShowThemeSwitcher(value)
    await updateProjectSwitchers(undefined, value)
  }

  return (
    <AccordionItem itemId='setting-switchers' title={<Trans>Switchers</Trans>}>
      <div className='flex flex-col gap-4 py-3 text-sm'>
        <div className='flex items-center justify-between gap-2'>
          <span className='text-zinc-600 dark:text-slate-300'>
            <Trans>Language Selector</Trans>
          </span>
          <Switch checked={showLanguageSwitcher} onClick={handleToggleLanguageSwitcher} />
        </div>

        <div className='flex items-center justify-between gap-2'>
          <span className='text-zinc-600 dark:text-slate-300'>
            <Trans>Theme Toggle</Trans>
          </span>
          <Switch checked={showThemeSwitcher} onClick={handleToggleThemeSwitcher} />
        </div>

        {(showLanguageSwitcher || showThemeSwitcher) && !topBarVisibility && (
          <div className='rounded-sm border border-amber-400/40 bg-amber-500/10 px-3 py-2 text-xs leading-normal text-amber-700 dark:text-amber-200'>
            <Trans>
              The top bar is currently hidden. Enable it from <strong>Top Navigation Bar</strong> settings to display
              the switchers in the app preview.
            </Trans>
          </div>
        )}
      </div>
    </AccordionItem>
  )
}
